<template>
  <div class='item'>
    <!-- <img :src="info.logoIcon" class="logo"> -->
    <div class="info">
      <div class="name">{{info.corpName}}</div>
      <div class="line">{{info.categoryLevel1Name}} {{info.categoryLevel2Name}}</div>
      <div class="line">{{info.leasedArea}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {};
      },
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
  .item{
    display: flex;
    &:not(:last-child){
      margin-bottom: 20px;
    }
    .logo{
      width: 140px;
      height: 140px;
      background-color: #ebebeb;
    }
    .info{
      flex: 1;
      line-height: 1;
      padding: 27px 20px;
      background-color: #fff;
      div{
        margin-bottom: 16px;
        &:last-child{
          margin-bottom: 0;
        }
      }
      .name{
        font-size: 20px;
        font-weight: bold;
      }
      .line{
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/navigator/corpList/components/child/Item.vue